import React from 'react';
import { Headline3, Icon, Subtitle1 } from 'venn-ui-kit';

const TagsEmptyState = () => {
  return (
    <div className="flex justify-center items-center h-[190px] flex-col">
      <Icon type="tag" className="text-venn-highlight-dark text-[20px] mb-[15px]" />
      <Headline3>Tags keep your library organized</Headline3>
      <Subtitle1>Start typing to create and manage tags.</Subtitle1>
    </div>
  );
};

export default TagsEmptyState;
